export const STORAGE_KEYS = {
  ACCESS_TOKEN: "ata-access-token",
};
